import { initialState } from "../store/initialState";
import { internalActionKeys } from "../actions/internalActionKeys";
import { AppContext } from "../types/appContext";
import { ReduxAction } from "../types/reduxAction";

export default function appContextReducer(
  state: AppContext = initialState.appContext,
  action: ReduxAction<AppContext>
): AppContext {
  switch (action.type) {
    case internalActionKeys.SAVE_APP_CONTEXT:
      return {
        ...action.payload
      };
    default:
      return state;
  }
}
